import { faArrowLeft, faCheck } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { getPathWithParam, MANAGE_FEE_ROUTES } from "../../../utils";

const FeeRunDetailsCard = () => {
  const history = useHistory();
  const [feeRunDetails, setFeeRunDetails] = useState([]);

  // const {feeRunId} = useRouterParams();

  // useDeepEffect(() => {
  //   setIsLoading(true);
  //   getPlanLevelFeeCollectedDetailsAfterTrade()
  //     .then((response) => {
  //       setIsLoading(false);
  //       // setFeeRunDetails(response?.feeSpecificationInformationDetails);
  //     })
  //     .catch((error) => {
  //       setIsLoading(false);
  //     });
  // }, []);
  return (
    <div className="feeRun-details-card">
      <div
        className="link blue-small ml-3 mt-3 padding-right-none cursor-pointer"
        onClick={() => {
          history.push(
            getPathWithParam({
              path: MANAGE_FEE_ROUTES.FEE_RUN,
            })
          );
        }}
      >
        <FontAwesomeIcon icon={faArrowLeft} /> Back
      </div>
      <p className="ml-3 mt-3 feeDetailsHeader">Fee Details</p>
      <p className="ml-3 mt-3 feeDetails">
        Fee details
        <div className="feeName">Oscorp Equity Admin Fee..</div>
      </p>

      <div className="ml-3 mt-3 statusCapsule">
        <FontAwesomeIcon
          style={{ fontSize: "10px", color: "#06741A" }}
          className="ml-2"
          icon={faCheck}
        />
        <span className="ml-2 statusCheck">Active</span>
        <p className="mt-2 description">
          File description goes here and text wi..
        </p>
      </div>
      <br />
      <hr className="ml-3 horizontalLine" />

      <p className="ml-3 mt-3 fw-500 ft-14" style={{ color: "#919191" }}>
        Classification
        <div className="valueData">Admin Fee</div>
      </p>

      <hr className="ml-3 horizontalLine" />

      <p className="ml-3 mt-3 fw-500 ft-14" style={{ color: "#919191" }}>
        Fee Type
        <div className="valueData">Balance based</div>
      </p>

      <hr className="ml-3 horizontalLine" />

      <p className="ml-3 mt-3 fw-500 ft-14" style={{ color: "#919191" }}>
        Schedule Type
        <div className="valueData">Recurring</div>
      </p>

      <hr className="ml-3 horizontalLine" />

      <p className="ml-3 mt-3 fw-500 ft-14" style={{ color: "#919191" }}>
        Fee run date
        <div className="valueData">
          08/05/2023
          <span className="fw-500 ft-14" style={{ color: "#919191" }}>
            {" "}
            14:12
          </span>
        </div>
      </p>
    </div>
  );
};

export default FeeRunDetailsCard;
